import { calculateTimeElapsedSinceLastTransitionOrMarkTime } from '../performanceTimeDifference';
import { mark } from '../performance';

var withSafeframeRenderDomContentLoadedEvent = function withSafeframeRenderDomContentLoadedEvent() {
  return function (adSpot, performance) {
    var groupId = adSpot.guid;
    var markName = "".concat(groupId, "_safeframe_render_dom_content_loaded");
    mark(markName, performance);
    var renderDomContentLoadedTime = calculateTimeElapsedSinceLastTransitionOrMarkTime(markName, performance);

    if (!renderDomContentLoadedTime) {
      return undefined;
    }

    return {
      schema: 'iglu:au.com.realestate/media_ads_safeframe_render_dom_content_loaded/jsonschema/1-0-0',
      data: {
        event_name: 'media_ads_safeframe_render_dom_content_loaded',
        safeframe_render_dom_content_loaded_time: renderDomContentLoadedTime
      }
    };
  };
};

export default withSafeframeRenderDomContentLoadedEvent;
//# sourceMappingURL=withSafeframeRenderDomContentLoadedEvent.js.map